import { useState, useCallback } from "react"
import { Toast } from "@/components/ui/toast"

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([])

  const addToast = useCallback((toast: Omit<Toast, "id">) => {
    const id = Math.random().toString(36).substring(7)
    setToasts((prev) => [...prev, { ...toast, id }])
  }, [])

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  const toast = useCallback((options: {
    title: string
    description?: string
    variant?: "default" | "success" | "destructive" | "confirmation"
    actions?: {
      confirm?: {
        label: string
        onClick: () => void
      }
      cancel?: {
        label: string
        onClick: () => void
      }
    }
  }) => {
    addToast(options)
  }, [addToast])

  return {
    toasts,
    toast,
    removeToast
  }
}